import type { Nullable } from 'corgi-types';

import { useLocalization } from '../../providers/LocaleProvider';

export interface RangeDisplayProps {
  selectedMin: Nullable<number>;
  selectedMax: Nullable<number>;
  unit?: string;
}

export const useGetRangeDisplayText = ({
  selectedMin,
  selectedMax,
  unit: initialUnit,
}: RangeDisplayProps) => {
  const { t } = useLocalization();
  const unit = initialUnit || '';
  if (!selectedMax && !selectedMin) {
    return '';
  }
  if (!selectedMax) {
    return `${t('h24_from')} ${selectedMin}${unit}`;
  }
  if (!selectedMin) {
    return `${t('h24_to')} ${selectedMax}${unit}`;
  }

  return `${selectedMin}${unit} - ${selectedMax}${unit}`;
};

const RangeDisplay = (props: RangeDisplayProps) => {
  const rangeDisplayText = useGetRangeDisplayText(props);

  return rangeDisplayText;
};

export default RangeDisplay;
